import * as contentful from 'contentful'

const SPACE_ID = 'p3zfkdn4q6yj'
const ACCESS_TOKEN =
  '8f5e862cdf781b1d6d0783b154c6a66eae7f34a84024ab166b6404d060fb9c13'

const client = contentful.createClient({
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken: ACCESS_TOKEN,
  // This is the space ID. A space is like a project folder in Contentful terms
  space: SPACE_ID,
})

function getEntries() {
  return client.getEntries({ limit: 300 })
}

export const allEntries = () => getEntries()



// WEBPACK FOOTER //
// ./src/api/api.ts